export function isCheckoutCancellationNeeded(isNavigatingTo?: string): boolean {
  return isNavigatingTo !== 'checkout-v2'
}
